<button
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  class="text-neutral-0 hover:border-primary-600 hover:bg-primary-600 flex items-center justify-center rounded-full border-2 p-2"
  [class.border-primary-500]="!cardOpen()"
  [class.bg-primary-500]="!cardOpen()"
  [class.border-primary-600]="cardOpen()"
  [class.bg-primary-600]="cardOpen()"
  (click)="toggleCard()"
>
  <mat-icon>tab</mat-icon>
</button>
@if (cardOpen()) {
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="cardOpen()"
    [cdkConnectedOverlayDisposeOnNavigation]="true"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayOffsetY]="8"
    (backdropClick)="closeCard()"
  >
    <mat-card>
      <mat-card-content class="w-[560px]">
        <div class="mb-4 flex items-center justify-between">
          <h4>{{ "memberComments.heading" | translate }}</h4>
          <button
            type="button"
            class="flex items-center justify-center"
            (click)="closeCard()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div>
          <members-comments-list [memberId]="memberId()"></members-comments-list>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-template>
}
